import React from "react";

const Footer = () => {
  return (
    <footer className="bg-cyan-500 p-10 text-gray-200 text-center">
      Copyright © 2036 WoOx Travel Company. All rights reserved. Design:
      TemplateMo
    </footer>
  );
};

export default Footer;
